import * as types from './types';

export const setMessage = message => ( { type: types.SET_MESSAGE, message } );
export const setSelectedEcard = ecard => ( { type: types.SET_SELECTED_ECARD, ecard } );
export const setPrivate = ( privateRec ) => ( { type: types.SET_PRIVATE_REC, privateRec } );